module.exports = __webpack_public_path__ + "static/c2-26083535aa31b93e6ebe97025d6df063.png";